import hljs from "highlight.js/lib/core";
import sql from "highlight.js/lib/languages/sql";

hljs.registerLanguage("sql", sql);

import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "highlightSql" })
export class HighlightSqlPipe implements PipeTransform {
  public transform(str: string) {
    if (!str) {
      return "";
    }

    return hljs.highlight(str, { language: "sql" }).value;
  }
}
